import { render, staticRenderFns } from "./TaskSelector.vue?vue&type=template&id=9dbd347a&"
import script from "./TaskSelector.vue?vue&type=script&lang=js&"
export * from "./TaskSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports